import { call, put, takeLatest } from "redux-saga/effects";

import {
  SUBMIT_CREATE_BENCHMARK_REQUEST,
  submitCreateBenchmarkSuccess,
  submitCreateBenchmarkFailure,
} from "../actions/createBenchmarkActions";

import { createBenchmark } from "../../../services/accIqService";

// function* handleCreateBenchmark(action) {
//   try {
//     const response = yield call(createBenchmark, action.payload);

//     yield put(submitCreateBenchmarkSuccess(response));
//   } catch (error) {
//     yield put(
//       submitCreateBenchmarkFailure(error?.response?.data || error.message)
//     );
//   }
// }

// export default function* createBenchmarkSaga() {
//   yield takeLatest(SUBMIT_CREATE_BENCHMARK_REQUEST, handleCreateBenchmark);
// }

function* handleCreateBenchmark(action) {
  try {
    const { user_id, user_role, user_type, client_company, competitors } =
      action.payload;

    const response = yield call(
      createBenchmark,
      user_id,
      user_role,
      user_type,
      client_company,
      competitors
    );

    yield put(submitCreateBenchmarkSuccess(response));
  } catch (error) {
    yield put(
      submitCreateBenchmarkFailure(error?.response?.data || error.message)
    );
  }
}

export default function* createBenchmarkSaga() {
  yield takeLatest(SUBMIT_CREATE_BENCHMARK_REQUEST, handleCreateBenchmark);
}
